<template>
  <div class="drag-drop-grid drdggrid text-noselect">
    <transition-group
      name="transition-move"
      tag="div"
      class="drdggrid_container"
    >
      <!-- @mousedown="(e) => handleDragstart({ e, item: cell })"
        @touchstart="(e) => handleDragstart({ e, item: cell })" -->
      <div
        v-for="cell in draggedCell ? l_cells : cells"
        :id="`${dropTargetIdPart}${cell.id}`"
        :key="cell.id"
        class="drdggrid_cell"
        :class="{
          drdggrid_cell_dragged: draggedId === cell.id,
        }"
      >
        <div class="drdggrid_cell_content">
          <slot
            :name="`cell_${cell.id}`"
            :dd_events="{
              handleDragstart,
            }"
            :cell="cell"
          >
            {{ cell.id }}
          </slot>
        </div>
        <slot
          :name="draggedId === cell.id ? 'draggedcell' : 'none'"
          :item="cell.item"
        >
        </slot>
      </div>
    </transition-group>

    <DragDropHandler
      ref="dragdrophandler"
      :dropTargetIdPart="dropTargetIdPart"
      :hasDefaultIndicator="false"
      @drag:over="handleDragover"
      @drag:drop="handleDragdrop"
    >
      <template #shallowitem>
        <slot
          name="shallowitem"
          :item="draggedCell ? draggedCell.item : null"
        >
          <div class="drdggrid_cell drdggrid_cell_floating">
            <div class="drdggrid_cell_content">
              {{ draggedCell }}
            </div>
          </div>
        </slot>
      </template>
    </DragDropHandler>
  </div>
</template>

<script>
import float_mix from '@/mixins/float_mix'
import DragDropHandler from '@/components/lib/DragDropHandler'

export default {
  name: 'DragDropGrid',
  components: {
    DragDropHandler,
  },
  mixins: [float_mix],
  props: {
    items: Array,
    dropTargetIdPart: { default: () => 'dragdropgrid_cell_' },
    idKey: { default: 'id' },
  },
  emits: ['update:cells'],
  data() {
    return {
      cells: [],
      l_cells: [],
      draggedCell: null,
    }
  },
  methods: {
    initialize() {
      this.cells = this.items.map((item, index) => ({
        id: item[this.idKey] || (index + 1).toString(),
        index,
        item,
      }))
      this.l_cells = []
      this.draggedCell = null
    },
    handleDragover(el) {
      if (!el) return
      const elId = el.id.replace(this.dropTargetIdPart, '')
      const item = this.cells.find(i => elId === i.id)
      this.repositionCell(item)
    },
    repositionCell(item) {
      if (!this.draggedCell) return
      if (item.id === this.draggedCell.id) return

      const res = JSON.parse(JSON.stringify(this.cells))
      const currIdx = res.findIndex(i => i.id === this.draggedCell.id)
      const newIdx = this.l_cells.findIndex(i => i.id === item.id)

      const switchItem = res[newIdx]
      res[newIdx] = this.draggedCell
      res[currIdx] = switchItem

      // if (currIdx > newIdx) {
      //   let afterItems = res.filter((_, idx) => idx >= newIdx && idx !== currIdx)
      //   let beforeItems = res.filter((_, idx) => idx < newIdx)
      //   res = [...beforeItems, this.draggedCell, ...afterItems]
      // } else {
      //   let beforeItems = res.filter((_, idx) => idx <= newIdx && idx !== currIdx)
      //   let afterItems = res.filter((_, idx) => idx > newIdx)
      //   res = [...beforeItems, this.draggedCell, ...afterItems]
      // }

      this.l_cells = res
      // console.log(res)
      // console.log(res.map(i => i.id))
      // debugger
    },
    handleDragstart({ e, item, cells = this.cells }) {
      e.preventDefault()
      this.draggedCell = item
      this.l_cells = JSON.parse(JSON.stringify(cells))
      // debugger
      if (this.$refs.dragdrophandler) {
        this.$refs.dragdrophandler.startDrag(e)
      }
    },
    handleDragdrop({ e, dropTarget, dropSurface }) {
      this.cells = this.l_cells
      this.draggedCell = null
      this.$emit('update:cells', this.cells)
    },
  },
  computed: {
    draggedId() {
      return this.draggedCell?.id || null
    },
  },
  watch: {
    items: {
      immediate: true,
      handler: 'initialize',
    },
  },
}
</script>

<style lang="scss">
.drdggrid {
  --display: grid;
  --grid-gap: 1rem;
  --grid-template-columns: repeat(3, 1fr);
  --grid-template-rows: repeat(3, 1fr);
  --grid-auto-flow: row;
  flex: 1;
  min-height: 0;
  &_container {
    display: var(--display);
    grid-template-columns: var(--grid-template-columns);
    grid-template-rows: var(--grid-template-rows);
    grid-auto-flow: var(--grid-auto-flow);
    grid-gap: var(--grid-gap);
    flex: 1;
    min-height: 0;
  }
  &_cell {
    position: relative;
    display: flex;
    --content-opacity: 1;
    z-index: 1;
    &:hover {
      z-index: 2;
    }
    &_content {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: var(--content-opacity);
      transition: 0.22s;
    }
    &_dragged {
      --content-opacity: 0;
      z-index: 3;
    }
  }
}

@media (max-width: 1023px) {
  .drdggrid {
    --grid-template-columns: unset;
    --grid-template-rows: unset;
    --grid-auto-flow: row;
  }
}

.transition-move-move {
  transition: transform 0.44s;
  pointer-events: none;
}
</style>
